module.exports = __webpack_public_path__ + "fonts/LineIconsPro Regular.fd8125b.woff2";